import React, { useState } from 'react';
import config from '../config';

const API_BASE = config.API_BASE;

export default function LockedPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const inputValue = email.trim();
    if (!inputValue) return;

    if (!inputValue.includes('@')) {
      setLoading(true);
      setError('');
      try {
        const response = await fetch(`${API_BASE}/api/locked-state/bypass`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ password: inputValue }),
        });
        const data = await response.json();
        if (data.success) {
          window.location.reload();
          return;
        }
        setError(data.error || 'Invalid password');
      } catch {
        setError('Could not verify password');
      } finally {
        setLoading(false);
      }
      return;
    }

    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${API_BASE}/api/email-signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: inputValue }),
      });
      const data = await response.json();
      if (data.success) {
        setSubmitted(true);
        setEmail('');
      }
    } catch {
      setError('Could not save signup');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .locked-page-form { flex-direction: column !important; width: 90% !important; max-width: 400px !important; }
          .locked-page-input { min-width: 100% !important; width: 100% !important; }
          .locked-page-button { width: 100% !important; }
        }
      `}</style>
      <div style={{
        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
        backgroundImage: 'url(/hero.jpg)', backgroundSize: 'cover', backgroundPosition: 'center',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
      }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: submitted ? 0 : '2rem', fontWeight: 'bold', color: '#fff' }}>
          COMING SOON
        </h1>
        {!submitted && (
          <form onSubmit={handleSubmit} className="locked-page-form" style={{ display: 'flex', gap: 0 }}>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              disabled={loading}
              className="locked-page-input"
              style={{ padding: '1rem 1.5rem', fontSize: '1rem', border: '1px solid #000', minWidth: '300px' }}
            />
            <button type="submit" disabled={loading} className="locked-page-button" style={{ padding: '1rem 2rem', backgroundColor: '#000', color: '#fff', border: '1px solid #000' }}>
              {loading ? 'Signing up...' : 'Sign Up'}
            </button>
          </form>
        )}
        {error && <p style={{ color: '#ffb4b4', marginTop: 16 }}>{error}</p>}
      </div>
    </>
  );
}
